<template>
  <el-button v-bind="$attrs" :disabled="$attrs.disabled" :loading="$attrs.loading" @click="onClick">
    <svg-icon v-if="$attrs['icon-class']" :icon-class="$attrs['icon-class']" />
    <slot name="default" />
    <template v-if="!$slots.default && $attrs.label">
      {{ $attrs.label }}
    </template>
  </el-button>
</template>
<script>
export default {
  name: 'ElButtonSvg',
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ElButtonSvg/elbuttonsvg.vue